import { FormBuilder, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { descripteursSyllabusValidators } from '@app/shared/base-form/validators-config';
import { DescripteursObjetFormationSyllabus, DescripteursSyllabus, TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { AbstractDescripteursForm } from '../../../../../../shared/form-models/abstract-descripteurs-form';

export class DescripteursSyllabusForm extends AbstractDescripteursForm {
    constructor(protected formGroup: FormGroup, protected readonly typeObjetMaquette: TypeObjetMaquette) {
        super(formGroup, typeObjetMaquette);
    }

    public static createForm(
        fb: FormBuilder | NonNullableFormBuilder,
        typeObjetMaquette: TypeObjetMaquette,
        descripteursSyllabus?: DescripteursSyllabus
    ) {
        const form = fb.group({
            autresInformations: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.autresInformations }),
            bibliographie: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.bibliographie }),
            contacts: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.contacts }),
            langueEnseignement: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.langueEnseignement }),
            modalitesEnseignements: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.modalitesEnseignements }),
            objectif: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.objectif }),
            ouvertureALaMobiliteEntrante: fb.control<boolean | null>(null, {
                validators: descripteursSyllabusValidators.ouvertureALaMobiliteEntrante
            }),
            prerequisPedagogique: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.prerequisPedagogique }),

            descripteursObjetFormationSyllabus: fb.group(
                {
                    coefficient: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.coefficient }),
                    modalitesEvaluation: fb.control<string | null>(null, {
                        validators: descripteursSyllabusValidators.modalitesEnseignements
                    }),
                    volumeHoraireParTypeDeCours: fb.control<string | null>(null, {
                        validators: descripteursSyllabusValidators.volumeHoraireParTypeDeCours
                    })
                },
                { validators: descripteursSyllabusValidators.descripteursObjetFormationSyllabus }
            ),
            description: fb.control<string | null>(null, { validators: descripteursSyllabusValidators.description })
        });
        if (descripteursSyllabus) {
            form.patchValue(descripteursSyllabus);
            if (typeObjetMaquette === TypeObjetMaquette.ObjetFormation) {
                form.controls.descripteursObjetFormationSyllabus.enable();
                form.controls.descripteursObjetFormationSyllabus.patchValue(descripteursSyllabus as DescripteursObjetFormationSyllabus);
            } else {
                form.controls.descripteursObjetFormationSyllabus.disable();
            }
        }

        return new DescripteursSyllabusForm(form, typeObjetMaquette);
    }

    public get asDescripteursSyllabus(): DescripteursSyllabus {
        let descripteurs = {
            typeObjetMaquette: this.typeObjetMaquette,
            objectif: this.formGroup.value.objectif,
            ouvertureALaMobiliteEntrante: this.formGroup.value.ouvertureALaMobiliteEntrante,
            langueEnseignement: this.formGroup.value.langueEnseignement,
            prerequisPedagogique: this.formGroup.value.prerequisPedagogique,
            bibliographie: this.formGroup.value.bibliographie,
            contacts: this.formGroup.value.contacts,
            autresInformations: this.formGroup.value.autresInformations,
            modalitesEnseignements: this.formGroup.value.modalitesEnseignements,
            description: this.formGroup.value.description
        };
        if (this.typeObjetMaquette === TypeObjetMaquette.ObjetFormation) {
            descripteurs = {
                ...descripteurs,
                ...this.formGroup.controls.descripteursObjetFormationSyllabus.getRawValue()
            };
        }
        return descripteurs;
    }
}
